class ClockHelper {
  
  constructor() {
    this.clockcanvas = null
  }

  initClock(clockcanvas) {
    this.clockcanvas = clockcanvas;

    this.clockcanvas.width = 400;
    this.clockcanvas.height = 400;
    let radius = this.clockcanvas.height / 2;
    this.clockcanvas.getContext("2d").translate(radius, radius);
    let that = this;
    setInterval(drawClock, 1000);


    function drawClock() {
      let clockctx = that.clockcanvas.getContext("2d");
      let radius = that.clockcanvas.height / 2 * 0.90;
      drawFace(clockctx, radius);
      drawNumbers(clockctx, radius);
      drawTime(clockctx, radius);
      clockctx.beginPath();
      clockctx.arc(0, 0, radius * 0.07, 0, 2 * Math.PI);
      clockctx.fillStyle = '#FF4F00';
      clockctx.fill();
    }

    function drawFace(clockctx, radius) {
      clockctx.beginPath();
      clockctx.arc(0, 0, radius, 0, 2 * Math.PI);
      clockctx.fillStyle = '#282e30';
      clockctx.fill();

    }

    function drawNumbers(clockctx, radius) {
      var ang;
      var num;
      clockctx.font = radius * 0.18 + "px arial";
      clockctx.fillStyle = "#f4f4f4"
      clockctx.textBaseline = "middle";
      clockctx.textAlign = "center";
      for (num = 1; num < 13; num++) {
        ang = num * Math.PI / 6;
        clockctx.rotate(ang);
        clockctx.translate(0, -radius * 0.85);
        clockctx.rotate(-ang);
        clockctx.fillText(num.toString(), 0, 0);
        clockctx.rotate(ang);
        clockctx.translate(0, radius * 0.85);
        clockctx.rotate(-ang);
      }
    }

    function drawTime(clockctx, radius) {
      var now = new Date();
      var hour = now.getHours();
      var minute = now.getMinutes();
      var second = now.getSeconds();
      //hour
      hour = hour % 12;
      hour = (hour * Math.PI / 6) +
        (minute * Math.PI / (6 * 60)) +
        (second * Math.PI / (360 * 60));
      drawHand(clockctx, hour, radius * 0.5, 6, "#ffffff");
      //minute
      minute = (minute * Math.PI / 30) + (second * Math.PI / (30 * 60));
      drawHand(clockctx, minute, radius * 0.8, 6, "#f0f0f0");
      // second
      second = (second * Math.PI / 30);
      drawHand(clockctx, second, radius * 0.9, 6, "#FF4F00");
    }

    function drawHand(clockctx, pos, length, width, color) {
      clockctx.beginPath();
      clockctx.strokeStyle = color
      clockctx.lineWidth = width;
      clockctx.lineCap = "round";
      clockctx.moveTo(0, 0);
      clockctx.rotate(pos);
      clockctx.lineTo(0, -length);
      clockctx.stroke();
      clockctx.rotate(-pos);
    }
  }



}
export default ClockHelper;